import { certLevelOptionsHtml } from "../utils.js";
import { register } from "../auth.js";
import { ApiError } from "../api.js";
import { navigate } from "../app.js";
import { takeReturn } from "../returnTo.js";


/** query: `email` fills in the address (the cohort invitation page sends the one it
 *  was emailed to); the reader can still change it. */
export function render(container, _params, query) {
  container.innerHTML = `
    <div class="auth-shell">
      <div class="card auth-card p-4">
        <div class="card-body">
          <h1 class="display-heading h4 mb-4 text-center">Create your account</h1>
          <form id="register-form" novalidate>
            <div class="mb-3">
              <label class="form-label" for="reg-email">Email</label>
              <input type="email" class="form-control" id="reg-email" required />
            </div>
            <div class="mb-3">
              <label class="form-label" for="reg-username">Username</label>
              <input type="text" class="form-control" id="reg-username" required />
            </div>
            <div class="mb-3">
              <label class="form-label" for="reg-display-name">Display name (optional)</label>
              <input type="text" class="form-control" id="reg-display-name" />
            </div>
            <div class="mb-3">
              <label class="form-label" for="reg-cert">Certification level (optional)</label>
              <select class="form-select" id="reg-cert">
                ${certLevelOptionsHtml(null)}
              </select>
            </div>
            <div class="mb-3">
              <label class="form-label" for="reg-password">Password</label>
              <input type="password" class="form-control" id="reg-password" required minlength="8" />
              <div class="form-text">At least 8 characters.</div>
            </div>
            <!-- For bots: hidden from people, screen readers, the Tab key and autofill. Bots fill
                 in every field, and the API quietly drops a sign-up with this one filled in. -->
            <div class="reg-extra" aria-hidden="true"
                 style="position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden">
              <label for="reg-website">Website</label>
              <input type="text" id="reg-website" name="website" tabindex="-1" autocomplete="off" />
            </div>
            <div id="register-error" class="text-danger small mb-3 d-none"></div>
            <button type="submit" class="btn btn-primary w-100" id="register-submit">Sign up</button>
            <p class="small text-muted mt-3 mb-0" id="register-terms">
              Your profile and what you post are public. By creating an account you agree to the
              <a href="terms.html" target="_blank" rel="noopener">Terms of Service</a> and the
              <a href="privacy.html" target="_blank" rel="noopener">Privacy Policy</a>.
            </p>
          </form>
          <p class="text-center mt-3 mb-0">
            <a href="#/login" id="register-to-login">Already have an account? Log in</a>
          </p>
        </div>
      </div>
    </div>`;

  const presetEmail = query?.get("email");
  if (presetEmail) {
    container.querySelector("#reg-email").value = presetEmail;
    // Switching to log in keeps it.
    container.querySelector("#register-to-login").href = `#/login?email=${encodeURIComponent(presetEmail)}`;
  }

  // When the form was shown: the API refuses a sign-up submitted quicker than a person could.
  const shownAt = Date.now();
  const form = container.querySelector("#register-form");
  const errorEl = container.querySelector("#register-error");
  const submitBtn = container.querySelector("#register-submit");

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    errorEl.classList.add("d-none");
    submitBtn.disabled = true;
    submitBtn.innerHTML = `<span class="spinner-border spinner-border-sm"></span>`;
    try {
      await register({
        email: container.querySelector("#reg-email").value.trim(),
        username: container.querySelector("#reg-username").value.trim(),
        displayName: container.querySelector("#reg-display-name").value.trim(),
        certificationLevel: container.querySelector("#reg-cert").value,
        password: container.querySelector("#reg-password").value,
        website: container.querySelector("#reg-website").value,
        formMs: Date.now() - shownAt,
      });
      navigate(takeReturn("/feed"));
    } catch (err) {
      errorEl.textContent = err instanceof ApiError ? err.message : "Something went wrong.";
      errorEl.classList.remove("d-none");
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = "Sign up";
    }
  });
}
